<template>
    <div class="login-page">
        <div class="login-side">
            <div class="side-content">
                <div class="side-badge">SG-SIM</div>
                <h2>Gestão digital para os Serviços de Inspeção Municipal</h2>
                <p>
                    Controle de estabelecimentos, documentos, vistorias,
                    anexos e rotinas técnicas em um único ambiente.
                </p>
            </div>
        </div>

        <div class="login-area">
            <div class="painel">
                <img
                    alt="iMolgaro Engenharia de Sistemas"
                    src="@/assets/imolgaro.png"
                    class="logo"
                >

                <h1>SG-SIM</h1>
                <h3>SISTEMA DE GESTÃO DOS SERVIÇOS DE INSPEÇÃO MUNICIPAL</h3>

                <form class="login-form" @submit.prevent="loginNew">
                    <div class="input-group">
                        <img src="@/assets/icons/mail.svg" alt="E-mail" class="icon" />
                        <input
                            type="text"
                            placeholder="Usuário/Email"
                            v-model="credenciais.userName"
                            autocomplete="username"
                        />
                    </div>

                    <div class="input-group">
                        <img src="@/assets/icons/pass.svg" alt="Senha" class="icon" />
                        <input
                            type="password"
                            placeholder="Senha"
                            v-model="credenciais.passWord"
                            autocomplete="current-password"
                        />
                    </div>

                    <NotRobotCheck v-model="notRobot" />

                    <button type="submit" class="login-button" :disabled="isLoading">
                        {{ isLoading ? 'Autenticando...' : 'Acessar' }}
                    </button>

                    <label
                        v-if="showRecuperarSenha"
                        class="label-link"
                        @click="recuperarSenha"
                    >
                        Recuperar senha
                    </label>

                    <div v-if="errorMessage" class="error-message">
                        {{ errorMessage }}
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>


<script setup>
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { genericPost, loginAPI } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import NotRobotCheck from '../NotRobotCheck.vue';

const credenciais = reactive({userName: '', passWord: ''});
const isLoading = ref(false);
const errorMessage = ref('');
const notRobot = ref(false);
const router = useRouter();


const showRecuperarSenha = false;

function recuperarSenha() {
    errorMessage.value = 'Função de recuperação de senha ainda não disponível.';
}



async function loginNew() {
    if ((!credenciais.userName) || (!credenciais.passWord)){
        errorMessage.value = 'Informe o usuário/email e senha';
        return;
    }
    if (!notRobot.value) {
        errorMessage.value = 'Por favor, confirme que você não é um robô';
        return;
    }

    try{
        isLoading.value = true;
        errorMessage.value = "";
        const dados = { appname: globalStore.appname, appver: globalStore.appver, login: credenciais.userName, senha: credenciais.passWord };
        const loginSuccess = await loginAPI(credenciais.userName, credenciais.passWord, dados);
        if (loginSuccess){
            const req = await genericPost('/main/registrarlogin', dados);
            if (req){
                globalStore.idlogin                     = req.idlogin;
                globalStore.idusuario                   = req.idusuario;
                globalStore.idep                        = req.idep;
                globalStore.idestabelecimento           = req.idestabelecimento;
                globalStore.idsim                       = req.idsim;
                globalStore.ckperfilgestor              = (req.perfilgestor === "S");
                globalStore.ckperfilsupervisor          = (req.perfilsupervisor === "S");
                globalStore.ckperfilinspetor            = (req.perfilinspetor === "S");
                globalStore.ckperfilestabelecimento     = (req.perfilestabelecimento=== "S");
                globalStore.ckperfilrt                  = (req.perfilrt === "S");
                globalStore.idperfil                    = req.idperfil;
                globalStore.nmperfil                    = req.nmperfil;
                globalStore.nmusuario                   = req.nmusuario;
                globalStore.nmep                        = req.nmep;
                globalStore.nmestabelecimento           = req.nmestabelecimento;
                globalStore.nmsim                       = req.nmsim;

                globalStore.showAcoesEstabelecimento    = (globalStore.ckperfilestabelecimento || globalStore.ckperfilrt);
                globalStore.showSelectEstabelecimento   = (!globalStore.ckperfilestabelecimento && !globalStore.ckperfilrt);
                globalStore.showSelectSim               = (globalStore.ckperfilsupervisor);

                if (globalStore.idestabelecimento > 0){
                    const atv = await genericPost('/listas/atividades', {idep: req.idep, intparam1: req.idestabelecimento});
                    if (Array.isArray(atv) && atv.length > 0) {
                        globalStore.atividade.id = atv[0].id;
                        globalStore.atividade.cdatividade = atv[0].cdatividade;
                        globalStore.atividade.nmatividade = atv[0].nmatividade;
                        globalStore.atividade.ckmpleite = (atv[0].ckmpleite === "S");
                        globalStore.atividade.ckmpmel = (atv[0].ckmpmel === "S");
                    }
                }
                if (globalStore.idperfil){router.replace('/main-page')} else
                if (globalStore.ckperfilestabelecimento || globalStore.ckperfilrt){router.replace('/main-estabelecimento')} else
                if (globalStore.ckperfilinspetor){router.replace('/main-inspetor')} else
                if (globalStore.ckperfilgestor){router.replace('/main-gestor')} else
                if (globalStore.ckperfilsupervisor){router.replace('/main-supervisor')} else {router.replace('/noroute')}
            }
        }else{errorMessage.value = "Login não autorizado"}        
    } catch (error){console.error('Erro leitura dos dados', error);
    } finally {isLoading.value = false;}
}
</script>

<style scoped>
.login-page {
    min-height: 100vh;
    display: grid;
    grid-template-columns: 1.15fr 0.85fr;
    background: #e5e7eb;
}

.login-side {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 48px;
    background:
        linear-gradient(135deg, rgba(15, 23, 42, 0.92), rgba(30, 64, 175, 0.82)),
        radial-gradient(circle at top left, #60a5fa, transparent 35%),
        radial-gradient(circle at bottom right, #16a34a, transparent 32%);
    color: white;
}

.side-content {
    max-width: 520px;
    text-align: left;
}

.side-badge {
    display: inline-block;
    padding: 8px 14px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.24);
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 1px;
    margin-bottom: 18px;
}

.side-content h2 {
    font-size: 38px;
    line-height: 1.12;
    margin: 0 0 18px;
    font-weight: 800;
}

.side-content p {
    font-size: 16px;
    line-height: 1.55;
    color: #dbeafe;
    margin: 0;
}

.login-area {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px;
    background: #f8fafc;
}

.painel {
    width: 100%;
    max-width: 430px;
    padding: 34px 36px;
    background: #ffffff;
    border: 1px solid #d9e2ec;
    border-radius: 18px;
    box-shadow: 0 18px 45px rgba(15, 23, 42, 0.12);
    text-align: center;
}

.logo {
    width: 180px;
    margin-bottom: 12px;
}

h1 {
    color: #0f172a;
    font-size: 2.3em;
    margin: 8px 0 4px;
}

h3 {
    color: #334155;
    font-size: 13px;
    line-height: 1.35;
    font-weight: 700;
    margin: 0 0 26px;
}

.login-form {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.input-group {
    position: relative;
}

.input-group input {
    width: 100%;
    padding: 12px 14px 12px 42px;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    font-size: 15px;
    background: #f8fafc;
    transition: 0.15s ease;
}

.input-group input:focus {
    outline: none;
    border-color: #1d4ed8;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.input-group .icon {
    position: absolute;
    left: 13px;
    top: 50%;
    transform: translateY(-50%);
    width: 19px;
    height: 19px;
    pointer-events: none;
    opacity: 0.72;
}

.login-button {
    width: 100%;
    padding: 12px 18px;
    font-size: 16px;
    font-weight: 700;
    color: white;
    background: #1e3a8a;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.15s ease;
}

.login-button:hover {
    background: #1d4ed8;
}

.login-button:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.label-link {
    font-size: 13px;
    color: #1d4ed8;
    cursor: pointer;
    margin-top: 2px;
}

.label-link:hover {
    text-decoration: underline;
}

.error-message {
    color: #dc2626;
    font-weight: 700;
    font-size: 13px;
    margin-top: 4px;
}

@media (max-width: 850px) {
    .login-page {
        grid-template-columns: 1fr;
    }

    .login-side {
        display: none;
    }

    .login-area {
        min-height: 100vh;
    }

    .painel {
        max-width: 420px;
        padding: 28px 24px;
    }
}
</style>